import { createFileRoute, useNavigate } from '@tanstack/react-router'
import React from 'react'
import PaymentCancelledModal from '../../../components/modals/PaymentCancelledModal'
import { useAuth } from '../../../contexts/AuthContext'
import { useClientProfile } from '../../../hooks/useClientProfile'
import { AppLayout } from '../../../components/layouts/AppLayout'
import {
  clearPendingCreditPurchase,
  PAYMENT_CREDITS_BEFORE_KEY,
  PAYMENT_RETURN_URL_KEY,
} from '../../../utils/paymentCheckout'

export const Route = createFileRoute('/billing/cancelled')({
  component: PaymentCancelledPage,
})

function PaymentCancelledPage() {
  const navigate = useNavigate()
  const { currentUser } = useAuth()
  const clientQuery = useClientProfile(currentUser?.email)

  const handleClose = () => {
    // Return to the original page where user was before payment
    const returnPath = sessionStorage.getItem(PAYMENT_RETURN_URL_KEY)
    sessionStorage.removeItem(PAYMENT_RETURN_URL_KEY)
    sessionStorage.removeItem(PAYMENT_CREDITS_BEFORE_KEY)
    clearPendingCreditPurchase()
    if (returnPath && returnPath !== '/') {
      navigate({ to: returnPath as any })
    } else {
      navigate({ to: '/campaigns' })
    }
  }

  const handleRetry = () => {
    // Return to the page where user can try again
    const returnPath = sessionStorage.getItem(PAYMENT_RETURN_URL_KEY)
    sessionStorage.removeItem(PAYMENT_RETURN_URL_KEY)
    sessionStorage.removeItem(PAYMENT_CREDITS_BEFORE_KEY)
    clearPendingCreditPurchase()
    if (returnPath && returnPath !== '/') {
      navigate({ to: returnPath as any })
    } else {
      navigate({ to: '/campaigns' })
    }
  }

  return (
    <AppLayout
      currentView="campaigns"
      aiCredits={clientQuery.data?.credits ?? 0}
      creditsLoading={clientQuery.isPending}
      clientInfo={clientQuery.data}
    >
      <PaymentCancelledModal isOpen={true} onClose={handleClose} onRetry={handleRetry} />
    </AppLayout>
  )
}
